import { render, staticRenderFns } from "./ShiftSelectDialog.vue?vue&type=template&id=0df517c1&scoped=true&"
import script from "./ShiftSelectDialog.vue?vue&type=script&lang=js&"
export * from "./ShiftSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSelectDialog.vue?vue&type=style&index=0&id=0df517c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df517c1",
  null
  
)

export default component.exports